<template>
<div id="bo-admin-import-main">
  <bo-import title="Import de nouveaux utilisateurs"
             subtitle="Back Office"
             :columns="columns"
             routePrefix="users"
             storePrefix="bouser">
  </bo-import>
</div>
</template>

<script>
import boImport from '@/components/boimport'

export default {
  name: 'admin-import',
  components: {
    'bo-import': boImport
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          name: 'Nom',
          mandatory: true
        },
        {
          field: 'firstName',
          name: 'Prénom',
          mandatory: true

        },
        {
          field: 'email',
          name: 'Emails',
          mandatory: true

        },
        {
          field: 'roles',
          name: 'Rôles',
          mandatory: true
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
